const React = require('react');
const withReDelay = require('mn-utils/withReDelay');
const toLower = require('mn-utils/toLower');
const {
  getRFC3339,
} = require('mn-utils/formatTime');
const RefreshIcon = require('@material-ui/icons/Refresh').default;
const OpenInNewIcon = require('@material-ui/icons/OpenInNew').default;
const {
  LINK_ADMIN_FAILED_AUCTIONS,
} = require('../../../../constants/links');
const {
  Link,
} = require('../../../../router');
const formatTime = require('../../../../utils/formatTime');
const formatNumCoin = require('../../../../utils/formatNumCoin');
const getExplorerUrlPrefixByCoin
  = require('../../../../utils/getExplorerUrlPrefixByCoin');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const Ripple = require('../../../dumb/Ripple');
const ButtonD = require('../../../dumb/Button/D');
const ButtonUp = require('../../../dumb/Button/Up');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const RowB = require('../../../dumb/Row/B');
const ColA = require('../../../dumb/Col/A');
const ColB = require('../../../dumb/Col/B');
const ReportDownload = require('../../../dumb/ReportDownload');
const {AdminTimeCell} = require("../../../dumb/TableTimeCell");
const formatCCSymbol = require("../../../../utils/formatCCSymbol");
const {TableNumberColAmin} = require("../../../dumb/TableNumberCol");

const {
  DisplayAmountAdmin,
  DisplayHashAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

const STATUS_MAP = {
  inblockhainanddb: 'FOUND',
  inblockchainanddb: 'FOUND',
  inblockchain: 'MISSED',
  inblockhain: 'MISSED',
  indb: 'ADDED',
};


function normalizeStatus(status) {
  status = status || '';
  return STATUS_MAP[toLower(status)] || status;
}


module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/transactionCollision')
      .apiAdminTransactionCollisionList,
  getParams: (self) => {
    const state = self.state || {};
    return {
      from: Math.floor(state.dateFrom.getTime() * 0.001),
      to: Math.floor(state.dateTo.getTime() * 0.001),
    };
  },
  wrapper(render, setState, self) {
    const dateTo = new Date();
    const dateFrom = new Date();
    dateFrom.setDate(dateTo.getDate() - 30);
    self.state = {
      ...(self.state || {}),
      dateTo,
      dateFrom,
    };

    const update = withReDelay(self.update, 1000);
    function handleChangeDateTo(dateTo) {
      setState({
        dateTo,
      });
      update();
    }
    function handleChangeDateFrom(dateFrom) {
      setState({
        dateFrom,
      });
      update();
    }

    function Item({
      data,
    }) {
      const {
        cc_code: coin,
        id,
      } = data;
      const ccAmount = data.cc_amount || 0;
      const hash = data.hash || '';
      const time = data.time || '';

      const status = normalizeStatus(data.status);

      const link = id
        ? (LINK_ADMIN_FAILED_AUCTIONS + id)
        : '';

      const inner = (
        <RowA>
          <ColA className="w155">
            <DisplayDateTimeAdmin date={time} />
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{formatCCSymbol(coin)}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <DisplayAmountAdmin
              amount={ccAmount}
              type="coin"
            />
            {/*<TableNumberColAmin*/}
            {/*  value={ccAmount}*/}
            {/*  type="coin"*/}
            {/*/>*/}
          </ColA>
          <ColA className="w(|min)150">
            <Tooltip>{(data.senders || []).join(', ')}</Tooltip>
          </ColA>
          <ColA className="wmin180 fx1">
            <DisplayHashAdmin
              symbol={coin}
              hash={hash}
              disabledEllipsedMode
            />
          </ColA>
          <ColA
            className={`wmin150 cFF7E7E.missed cFF0.added `
              + toLower(status)}
          >
            <Tooltip>{status}</Tooltip>
          </ColA>
          <ColA className="w50">
            {
              link ? (
                <div className="mr-35 rt">
                  <Ripple
                    className="layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                      bgF.03:h"
                    centerRipple
                    component={Link}
                    href={link}
                  >
                    <OpenInNewIcon/>
                  </Ripple>
                </div>
              ) : null
            }
          </ColA>
        </RowA>
      );

      return link ? (
        <Ripple
          component={Link}
          className="olN tdN dB w cF dn bgF.03:h"
          href={link}
        >{inner}</Ripple>
      ) : inner;
    }

    return (state) => {

      return (
        <LayoutA className="wmin1030*2">
          <HeaderA>
            <CaptionA>Blockchain</CaptionA>
            <ButtonD
              className="wmin100"
              onClick={self.update}
            >
              <RefreshIcon/>
              <div className="pl15">Refresh</div>
            </ButtonD>
          </HeaderA>
          <ReportDownload
            urlPrefix="/v1/admin/transaction-collision/report/"
            dateTo={state.dateTo}
            dateFrom={state.dateFrom}
            onChangeDateTo={handleChangeDateTo}
            onChangeDateFrom={handleChangeDateFrom}
          />
          <div className="abs st145 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin850 rlv h">
                <div>
                  <RowB className="f14">
                    <ColB className="w155">Time</ColB>
                    <ColB className="w(|min)100">CC Code</ColB>
                    <ColB className="w(|min)110">CC Amount</ColB>
                    <ColB className="w(|min)150">Sender</ColB>
                    <ColB className="wmin180 fx1">Hash</ColB>
                    <ColB className="wmin150">Status</ColB>
                    <ColB className="w50"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
